import { Device } from 'shared/types';
import { History } from 'history';
import { pages } from 'constants/urls';

export const isDeviceNotWeb = (device: Device) => device !== Device.WEB;

export const isDeviceIos = (device: Device) => device === Device.IOS;

export const isDeviceAndroid = (device: Device) => device === Device.ANDROID;

export const handleGoBack = (device: Device, history: History) => {
  if (isDeviceAndroid(device)) {
    window?.AndroidFunction?.finish();
  } else if (isDeviceIos(device)) {
    window?.webkit?.messageHandlers?.finish?.postMessage('Portfolio created');
  } else {
    history.goBack();
  }
};

export const getDevice = (device: number) => {
  if (device === 0) {
    return 'ANDROID';
  }

  if (device === 1) {
    return 'IOS';
  }

  return 'MSITE';
};

export const handleGoToHomePage = (device: Device) => {
  if (isDeviceAndroid(device)) {
    window?.AndroidFunction?.showHomepage();
  } else if (isDeviceIos(device)) {
    window?.webkit?.messageHandlers?.showHomepage?.postMessage('required');
  } else {
    window.location.href = `${pages.HOME}`;
  }
};
